module.exports = __webpack_public_path__ + "img/maintenance.fba4d216.png";